import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { StringRequest } from "../../class-attendance-excuse-setup/shared/StringRequest";
import { DataService_TimeScanTypeSetup } from "../shared/data.service";
import { TimeScanTypeUpdateRequest } from "../shared/TimeScanTypeUpdateRequest";

@Component({
	selector: "app-admin-setup-edit-time-scan-type",
	templateUrl: "./admin-setup-edit-time-scan-type.component.html",
	styleUrls: ["./admin-setup-edit-time-scan-type.component.css"],
})
export class AdminSetupEditTimeScanTypeComponent implements OnInit {
	constructor(
		private dialogConfig: DynamicDialogConfig,
		private ref: DynamicDialogRef,
		private confirmationService: ConfirmationService,
		private adminSetupService: DataService_TimeScanTypeSetup
	) {}

	ngOnInit(): void {
		//Load data from parent
		this.user = this.dialogConfig.data.user;
		this.SchoolID = this.dialogConfig.data.SchoolID;
		this.SelectedTST = this.dialogConfig.data.SelectedTST;

		this.Code = this.SelectedTST.TimeScanTypeCD;
		this.OriginalCode = this.SelectedTST.TimeScanTypeCD;

		this.Desc = this.SelectedTST.TimeScanTypeDesc;
		this.OriginalDesc = this.SelectedTST.TimeScanTypeDesc;

		this.AllSchools = this.SelectedTST.SchoolID == 0;
	}

	///////////////////////////////////////
	// Data
	///////////////////////////////////////

	//Data from parent
	user: any;
	SchoolID: any;
	SelectedTST: any;

	//Form
	Code: any = "";
	OriginalCode: any = "";

	Desc: any = "";
	OriginalDesc: any = "";

	AllSchools: any = false;

	errorMessage: any = "";

	///////////////////////////////////////

	///////////////////////////////////////
	// Buttons
	///////////////////////////////////////
	onUpdate() {
		if (String(this.Code) != String(this.OriginalCode)) {
			this.CheckCode();
		} else if (String(this.Desc) != String(this.OriginalDesc)) {
			this.CheckDesc();
		} else {
			this.FinishUpdate();
		}
	}

	CheckCode() {
		let parms: StringRequest = {
			str: this.Code,
		};

		var result = this.adminSetupService.TimeScanTypeCodeInUse(parms);
		result.subscribe(
			(response) => {
				if (response) {
					this.errorMessage = "Time Scan Type Code already in use";
					return;
				} else {
					if (String(this.Desc) != String(this.OriginalDesc)) {
						this.CheckDesc();
					} else {
						this.FinishUpdate();
					}
				}
			},
			(error) => {}
		);
	}

	CheckDesc() {
		let parms: StringRequest = {
			str: this.Desc,
		};

		var result = this.adminSetupService.TimeScanTypeDescInUse(parms);
		result.subscribe(
			(response) => {
				if (response) {
					this.errorMessage = "Time Scan Type Description already in use";
					return;
				} else {
					this.FinishUpdate();
				}
			},
			(error) => {}
		);
	}

	FinishUpdate() {
		let parms: TimeScanTypeUpdateRequest = {
			TimeScanTypeID: this.SelectedTST.TimeScanTypeID,
			TimeScanTypeCD: this.Code,
			TimeScanTypeDesc: this.Desc,
		};

		var result = this.adminSetupService.TimeScanTypeUpdate(parms);
		result.subscribe(
			(response) => {
				if (response) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "edit",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Time Scan Type was updated successfully",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.ref.close(1);
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "edit",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not update the Time Scan Type",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {}
		);
	}

	onClose() {
		this.ref.close(0);
	}
	///////////////////////////////////////
}
